import { useSelector } from 'react-redux';
import { Label } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { FORUM_FAVOURITE_TOPICS_URL, FORUM_HOME_URL, FORUM_OWN_TOPICS_URL } from 'constants/routes';
import { getUser } from 'state/session/selectors';
import OtherLink from '../OtherLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Communities = () => {
  const translate = useTranslate('header.main_navigation.about.communities');
  const user = useSelector(getUser);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      styling: Label.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/_jsx(OtherLink, {
      title: translate('items.forum'),
      url: FORUM_HOME_URL
    }), !!(user !== null && user !== void 0 && user.favourite_topic_count) && /*#__PURE__*/_jsx(OtherLink, {
      title: translate('items.forum_favourite_topics'),
      url: FORUM_FAVOURITE_TOPICS_URL
    }), !!user && /*#__PURE__*/_jsx(OtherLink, {
      title: translate('items.forum_own_topics'),
      url: FORUM_OWN_TOPICS_URL
    })]
  });
};

export default Communities;